import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'EditAdditionalPersonalDataDialogController',
            EditAdditionalPersonalDataDialogController
        );

    /** @ngInject */
    function EditAdditionalPersonalDataDialogController(
        $scope,
        $state,
        CompaniesFactory,
        ngDialog,
        toastr
    ) {
        var vm = this;
        var companyId;

        init();

        function init() {
            companyId = $scope.ngDialogData.company;

            vm.issue = angular.copy($scope.ngDialogData.issue);
            vm.save = save;
        }

        function save() {
            CompaniesFactory.editIssue(companyId, vm.issue.id, {
                additional_personal_data: vm.issue.additional_personal_data,
            }).then(function () {
                toastr.success('Zapisano');
                ngDialog.close();
                $state.reload('company_employee.issue_list.details');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-additional-personal-data/change-additional-personal-data.controller.ts